import { gql } from '@apollo/client';

export const ADD_AUDIT_LOG = gql`
  mutation addAuditLog($input: AddAuditLogInput!) {
    addAuditLog(input: $input) {
     clientMutationId
     errors
    }
  }
`
